import type { MouseEventHandler } from 'react';
import styled from 'styled-components';
import type { ButtonProps } from '@elfsight/widget-ui';
import { Button } from '@elfsight/widget-ui';
import type { ChatsChannelSetting } from '../../../constants/types';
import { useChat } from '../../chat';
import { getAppData } from '../../helpers';
import { useButtonOpenLink, useButtonStyles } from '../utils';

export const ChatButton = ({
  link,
  title,
  withCaption,
  icon,
  color
}: ChatsChannelSetting) => {
  const { setTargetChatButton } = useChat();
  const buttonStyles = useButtonStyles({
    title,
    icon,
    color
  });
  const openLink = useButtonOpenLink({ ...link, title });

  const buttonClickHandler: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.preventDefault();
    openLink();

    withCaption && setTargetChatButton(getAppData(title));
  };

  return (
    <DefaultButtonComponent
      {...(buttonStyles as Partial<ButtonProps>)}
      href={link?.url || ''}
      onClick={buttonClickHandler}
    />
  );
};

// добавлен href пропс, не поддерживаемый компонентом button, для того чтобы не сломать кастомные скрипты у клиентов
const DefaultButtonComponent = styled(Button)<{ href?: string }>`
  backface-visibility: hidden;
  overflow: hidden;

  & span > div,
  & svg {
    width: 24px;
    height: 24px;
  }

  html[dir='rtl'] && span > div {
    margin-left: ${({ iconOnly }) => !iconOnly && '8px'};
    margin-right: ${({ iconOnly }) => !iconOnly && '-4px'};
  }
`;
